module.exports = __webpack_public_path__ + "assets/jpg.fe83d00020f3d7e62d70ea6a389e076c.svg";


//////////////////
// WEBPACK FOOTER
// ./img/jpg.svg
// module id = 920
// module chunks = 0